import {
  Directive,
  ElementRef, Inject,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewContainerRef,
} from '@angular/core';
import { FullscreenButtonComponent } from './fullscreen-button/fullscreen-button.component';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appFullscreen]'
})
export class FullscreenDirective implements OnInit {

  private elem: any;
  private toggleSubscription: Subscription;

  constructor(
      @Inject(DOCUMENT) private document: any,
      @Inject(PLATFORM_ID) private platformId: any,
      private viewRef: ViewContainerRef,
      private el: ElementRef,
      private renderer: Renderer2
  ) { }



  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.elem = this.el.nativeElement;
      // const componentFactory = this.componentFactoryResolver.resolveComponentFactory(FullscreenButtonComponent as Type<any>);
      this.viewRef.clear();
      const ctaRef = this.viewRef.createComponent(FullscreenButtonComponent);
      // const ctaRef = this.viewRef.createComponent(componentFactory);
      this.renderer.appendChild(this.viewRef.element.nativeElement, ctaRef.injector.get(FullscreenButtonComponent).elRef.nativeElement);

      // set default status
      ((ctaRef.instance) as FullscreenButtonComponent).fullScreenIsOpened = false;
      // listent to button events
      this.toggleSubscription = ((ctaRef.instance) as FullscreenButtonComponent).toggleFullscreen
          .subscribe((fullScreenState) => {
            if (fullScreenState) {
              this.openFullscreen();
            } else {
              this.closeFullscreen();
            }
          });
    }
  }

  openFullscreen() {
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  /* Close fullscreen */
  closeFullscreen() {
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }

}
